<template>
  <div id="edit-problem" v-if="userinfo.isAdmin">
    <b-container fluid="sm">
      <h1 v-if="this.$route.path == '/problem/add'">New Problem</h1>
      <h1 v-else>Edit Problem {{ this.$route.params.id }}</h1>

      <b-form @submit="onSubmit" style="text-align: left; margin-bottom: 10px">
        <b-form-group
          id="input-group-1"
          label="Title"
          label-for="problem_title"
        >
          <b-form-input
            id="problem_title"
            type="text"
            :value="this.problem_title"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Google Drive File ID for PDF"
          label-for="description"
        >
          <b-form-input
            id="description"
            type="text"
            :value="this.description"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="GitLab Project ID"
          label-for="project_id"
        >
          <b-form-input
            id="project_id"
            type="number"
            :value="this.project_id"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label="GitLab Project Branch"
          label-for="branch"
        >
          <b-form-input
            id="branch"
            type="text"
            placeholder="main, master, slave..."
            :value="this.branch"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-5"
          label="Cool Down Time (Minutes)"
          label-for="cooldown_time"
        >
          <b-form-input
            id="cooldown_time"
            type="number"
            placeholder="minutes"
            :value="this.cooldown_time"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-6"
          label="Release Date"
          label-for="release_date"
        >
          <b-form-input
            id="release_date"
            type="datetime-local"
            step="1"
            :value="this.release_date"
            required
          ></b-form-input>
        </b-form-group>
        <!---
        <b-form-group
          id="input-group-6"
          label="Score Start Date"
          label-for="score_start_date"
        >
          <b-form-input
            id="score_start_date"
            type="datetime-local"
            :value="this.score_start_date"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        --->
        <b-form-group
          id="input-group-7"
          label="Deadline"
          label-for="score_end_date"
        >
          <b-form-input
            id="score_end_date"
            type="datetime-local"
            step="1"
            :value="this.score_end_date"
            required
          ></b-form-input>
        </b-form-group>
        <div
          class="form-row"
          v-for="(checkpoint, index) in problem_attributes"
          :key="index"
          style="margin-bottom: 10px"
        >
          <b-input-group prepend="Attribute" class="mt-2">
            <b-form-input
              v-model="problem_attributes[index].title"
              placeholder="Display Name"
              :required="origin_attribute_num >= 1"
            ></b-form-input>
            <b-form-input
              v-model="problem_attributes[index].key"
              placeholder="Variable"
              :required="origin_attribute_num >= 1"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="addAttributefield"
                >Add</b-button
              >
              <b-button
                variant="danger"
                @click="
                  d_title = problem_attributes[index].title;
                  d_id = problem_attributes[index].id;
                  checkDeleteAttribute(index);
                "
                >Del</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </div>
        <center>
          <b-button
            v-if="this.$route.path == '/problem/add'"
            type="submit"
            variant="primary"
            class="mt-3"
            >Add Problem</b-button
          >
          <b-button v-else type="submit" variant="primary" class="mt-3"
            >Update Problem</b-button
          >
        </center>
      </b-form>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>
            This action will delete Attribute "{{ d_title }} (ID:{{ d_id }})".
          </p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button class="mt-3" variant="primary" @click="hideWarning"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteAttribute(d_id)"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
export default {
  created() {
    this.get_user_info();
    this.getAttributes();
    if (this.$route.params.id != undefined) {
      this.getProblem();
    }
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  data() {
    return {
      checkNum() {
        return !isNaN(this.project_id.value);
      },
      problem_title: "",
      description: "",
      project_id: "",
      branch: "",
      cooldown_time: "",
      release_date: "",
      score_start_date: "",
      score_end_date: "",
      origin_attribute_num: 0,
      problem_attributes: [
        {
          title: "",
          key: "",
        },
      ],
      d_title: undefined,
      d_id: undefined,
      cooldown: 0,
      timeInterval: 0,
      userinfo: {
        isAdmin: false,
        isActive: false,
      },
      currentIndex: 0,
    };
  },
  methods: {
    onSubmit(submitEvent) {
      let self = this;
      let data = {
        title: submitEvent.target.elements.problem_title.value,
        description: submitEvent.target.elements.description.value,
        project_id: submitEvent.target.elements.project_id.value,
        branch: submitEvent.target.elements.branch.value,
        cooldown_minutes: submitEvent.target.elements.cooldown_time.value,
        release_date: submitEvent.target.elements.release_date.value,
        score_start_date: submitEvent.target.elements.release_date.value,
        score_end_date: submitEvent.target.elements.score_end_date.value,
      };

      this.problem_attributes.forEach(function (item, i) {
        if (i < self.origin_attribute_num) {
          self.updateAttribute(item);
        } else {
          self.addAttribute(item);
        }
      });
      if (this.$route.params.id != undefined) {
        this.update_problem(data);
      } else {
        this.add_problem(data);
      }
      this.$router.push({ name: "Problems" });
    },
    add_problem(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/";
      this.$http.post(api, data, {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      });
    },
    update_problem(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id;
      this.$http.patch(api, data, {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      });
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
          if (!self.userinfo.isAdmin) {
            self.$router.push({ name: "Home" });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              self.$router.push({ name: "Home" });
            }
          }
        });
    },
    getProblem() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id;
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.problem_title = response.data.title;
          self.description = response.data.description;
          self.project_id = response.data.project_id;
          self.branch = response.data.branch;
          self.cooldown_time = response.data.cooldown_minutes;
          self.release_date = response.data.release_date;
          self.score_start_date = response.data.score_start_date;
          self.score_end_date = response.data.score_end_date;
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    toProblem(problem_id) {
      this.$router.push({
        name: "Problem",
        path: `"/problem/"${problem_id}`,
      });
    },
    addAttributefield() {
      this.problem_attributes.push({
        title: "",
      });
    },
    getAttributes() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/attribute";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response.data.length != 0) {
            self.problem_attributes = response.data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            });
            self.origin_attribute_num = self.problem_attributes.length;
          } else {
            self.problem_attributes = [
              {
                title: "",
              },
            ];
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    addAttribute(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/attribute";
      //let self = this;
      let addData = {};
      if (data.key == undefined) {
        return;
      } else {
        addData = {
          problem_id: this.$route.params.id,
          title: data.title,
          key: data.key.toUpperCase(),
        };
      }
      this.$http
        .post(api, addData, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    updateAttribute(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/attribute/" + data.id;
      //let self = this;
      let editData = {};
      if (data.key == undefined) {
        return;
      } else {
        editData = {
          problem_id: this.$route.params.id,
          key: data.key.toUpperCase(),
          title: data.title,
        };
      }

      this.$http
        .patch(api, editData, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    checkDeleteAttribute(index) {
      let self = this;
      if (index < this.origin_attribute_num) {
        self.$refs["warning"].show();
      } else {
        self.problem_attributes.splice(index, 1);
      }
    },
    deleteAttribute(id) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/attribute/" + id;
      let self = this;
      this.$http
        .delete(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .finally(() => {
          self.getAttributes();
          self.hideWarning();
        });
    },
    hideWarning() {
      this.$refs["warning"].hide();
    },
  },
  computed: {},
};
</script>